import { useContext, type ReactNode } from "react";
import { createPortal } from "react-dom";
import { Check } from "lucide-react";
import { Button, Field, FieldError } from "../../../components/ui";
import { ContextMenuSlotsContext } from "./contextMenuSlots";

type EditFieldProps = {
  label: string;
  children: ReactNode;
};

export const EditField = ({ label, children }: EditFieldProps) => (
  <Field label={label}>{children}</Field>
);

type EditActionsProps = {
  saving: boolean;
  error: string;
  saveDisabled?: boolean;
  onSave: () => void;
  onCancel?: () => void;
};

export const EditActions = ({
  saving,
  error,
  saveDisabled,
  onSave,
  onCancel,
}: EditActionsProps) => {
  const { actions } = useContext(ContextMenuSlotsContext);

  const buttons = (
    <>
      <Button
        variant="primary"
        size="sm"
        disabled={saving || saveDisabled}
        onClick={(event) => {
          event.stopPropagation();
          onSave();
        }}
      >
        <Check size={14} />
        {saving ? "Saving…" : "Save"}
      </Button>
      <Button
        variant="ghost"
        size="sm"
        disabled={saving}
        onClick={(event) => {
          event.stopPropagation();
          onCancel?.();
        }}
      >
        Cancel
      </Button>
    </>
  );

  return (
    <>
      {error && <FieldError>{error}</FieldError>}
      {actions ? (
        createPortal(buttons, actions)
      ) : (
        <div className="flex items-center gap-2">{buttons}</div>
      )}
    </>
  );
};
